export enum ServiceEventStatus {
    loading     =   "loading",
    fetched     =   "fetched",       
}

export class ServiceEvent{
    
    ServiceEventStatus : typeof ServiceEventStatus = ServiceEventStatus;

    constructor(public type: ServiceEventStatus, public value: any){

    }
}